export default __webpack_public_path__ + "static/media/stage2_documents_2.a6a3a4ed.jpg";